export * from './truncate.pipe';
